import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgQuickreply = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	height: 20,
	viewBox: "0 -960 960 960",
	width: 20,
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M96-96v-696q0-29 21.5-50.5T168-864h624q29.7 0 50.85 21.5Q864-821 864-792v240h-72v-240H168v522l42-42h390v72H240L96-96Zm72-216v-480 480ZM750-48v-192h-78v-240h192l-60 156h84L750-48Z" })
});
export default SvgQuickreply;
